import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { FORMAT_SAMPLE } from './parse';

// Xato / ogohlantirishlar ro'yxati (qator raqami bilan)
export function IssueList({ items }) {
    if (!items || items.length === 0) return null;
    return (
        <ul className="sn-issues">
            {items.map((item, index) => (
                <li key={`${item.line}-${index}`}>
                    {item.line ? <span className="sn-issues__line">{item.line}-qator:</span> : null} {item.message}
                </li>
            ))}
        </ul>
    );
}

export function FormatSample() {
    return <pre className="sn-sample">{FORMAT_SAMPLE}</pre>;
}

// Rad etilgan fayl xabari
export function RejectedFile({ result }) {
    if (!result) return null;
    return (
        <div className="sn-alert sn-alert--error" role="alert">
            <div className="sn-alert__title">«{result.fileName}» qabul qilinmadi</div>
            <IssueList items={result.errors} />
            {result.noMarkers && (
                <>
                    <div className="sn-alert__hint">Namuna:</div>
                    <FormatSample />
                </>
            )}
        </div>
    );
}

// document.body'ga portal: sahifadagi transform/overflow va UpdateLessons modalidan mustaqil
export function SnModal({ title, onClose, children, footer, labelledBy = 'sn-modal-title' }) {
    useEffect(() => {
        const onKey = (event) => {
            if (event.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [onClose]);

    return createPortal(
        <div
            className="sn-overlay"
            onClick={(event) => {
                if (event.target === event.currentTarget) onClose();
            }}
        >
            <div className="sn-modal" role="dialog" aria-modal="true" aria-labelledby={labelledBy}>
                <div className="sn-modal__head">
                    <h2 id={labelledBy} className="sn-modal__title">{title}</h2>
                    <button type="button" className="sn-modal__close" onClick={onClose} aria-label="Yopish">×</button>
                </div>
                <div className="sn-modal__body">{children}</div>
                {footer && <div className="sn-modal__foot">{footer}</div>}
            </div>
        </div>,
        document.body
    );
}

const BADGES = {
    txt: { label: 'TXT', className: 'sn-badge sn-badge--info', title: 'Matn fayldan olingan' },
    ai: { label: 'AI', className: 'sn-badge sn-badge--warning', title: "Server bergan matn, hali o'zgartirilmagan" },
    edited: { label: 'Tahrirlangan', className: 'sn-badge sn-badge--neutral', title: "Qo'lda o'zgartirilgan" },
};

// 2-qadam: har sahifa maydoni ostidagi manba belgisi va belgilar soni
export function SpeakerNotesMeta({ state, length }) {
    const badge = BADGES[state];
    return (
        <div className="sn-meta">
            {badge ? <span className={badge.className} title={badge.title}>{badge.label}</span> : <span />}
            <span className="sn-count">{length} belgi</span>
        </div>
    );
}
